<template>
  <div class="max-w-[80rem] p-8 mx-auto w-full h-full relative">
    <div class="bg-[#FBFBFC] h-full py-6 rounded-3xl shadow-b-xl">
      <div class="h-full px-6 overflow-auto">
        <div class="absolute right-12 top-12" @click="$router.back">
          <img
            src="@/assets/images/all/close.svg"
            class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-black"
            alt=""
          />
        </div>
        <div class="mb-6">
          <div class="py-4"></div>
          <div class="text-center font-bold title-color text-3xl">
            Ajouter un produit
          </div>
          <div class="py-4"></div>
          <ProductForm @productSubmitted="handleSubmit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ProductForm from './ProductForm.vue'

export default defineComponent({
  name: 'AddNewProduct',
  components: {
    ProductForm,
  },
  data() {
    return {
      eventsIds: [], // Stocke les IDs des écouteurs d'événements
    }
  },
  mounted() {
    // Écoute des événements pour la création du produit
    const id = this.$Events.handleEvent(
      'product_created',
      this.onProductCreated,
    )
    const id2 = this.$Events.handleEvent(
      'failed_to_create_product',
      this.onProductCreationFailed,
    )
    this.eventsIds.push(id, id2)
  },
  beforeUnmount() {
    // Nettoyage des écouteurs d'événements
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    // Soumission du formulaire
    handleSubmit(formData) {
      console.log('Données du formulaire:', formData)
      this.$Events.dispatchEvent('new_product_ready_to_be_added', formData)
      this.$Events.dispatchEvent('start_loading')
    },
    // Gestion de la création réussie
    onProductCreated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Produit créé',
        body: 'Votre produit a été créé avec succès',
      })
      this.$router.back()
    },
    // Gestion de l'échec de la création
    onProductCreationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Produit non créé',
        body: 'Erreur de création du produit, veuillez réessayer',
      })
    },
  },
})
</script>

<style scoped></style>
